import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';
import MultiSelect from '../../../../components/multi-select';
import Styles from './styles';

const SitesFilter = ({ onChange, municipalities, classes }) => (
    <div className={classes.municipalityFilter}>
        <MultiSelect
            label="Filter testers by municipality values"
            defaultValue="All Municipalities"
            options={municipalities}
            onChange={onChange}
        />
    </div>
);

SitesFilter.propTypes = {
    municipalities: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(SitesFilter, Styles);
